const PAYMENT_HOSTS = new Set(['payments.comgate.cz', 'pay1.comgate.cz', 'pay2.comgate.cz']);

export class PaymentRedirectError extends Error {
  constructor() {
    super('Platba byla vytvořena, ale odkaz na platební bránu není platný. Kontaktujte podporu.');
  }
}

export function validatePaymentRedirect(redirect: unknown): string {
  if (typeof redirect !== 'string' || !redirect) throw new PaymentRedirectError();
  let url: URL;
  try {
    url = new URL(redirect);
  } catch {
    throw new PaymentRedirectError();
  }
  if (
    url.protocol !== 'https:' ||
    !PAYMENT_HOSTS.has(url.hostname) ||
    url.username ||
    url.password ||
    url.port
  ) {
    throw new PaymentRedirectError();
  }
  // Comgate requires its complete redirect URL to be passed through unchanged.
  return redirect;
}
